import './StatusMetForm.scss'

import React, { Component } from 'react'
import { AGENT_STATUS_MET } from 'common/constants'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { NoteField } from 'manager/views/components/ReferralStatus/NoteField'
import { saveStatus } from 'manager/redux/referral_status'
import { selectHasTourInfoOrValidNote, selectNote } from 'manager/selectors/referral_status_selectors'
import { selectIsPropertyInquiryTourUpdateNeeded, selectReferralStatusIsInvalid } from 'manager/selectors/referral_selectors'
import { selectAgentVideoCallEnabled } from 'manager/selectors/auth'
import { StatusSubmitButton } from 'manager/views/components/ReferralStatus/StatusSubmitButton'
import { withRouter } from 'react-router'
import { show as showModal } from 'redux-modal'
import PropertyTourQuestions from 'manager/views/components/ReferralStatus/PropertyTourQuestions'


class MetForm extends Component {
  constructor() {
    super()
  }

  state = { confirmedValidMet: false }

  confirmValidMet = () => {
    this.setState({ confirmedValidMet: true })
  }

  render() {
    const {
      hasTourInfoOrValidNote,
      isTourUpdateNeeded,
      note,
      isAgentVideoCallEnabled,
      saveStatus,
      isStatusInvalid,
      showModal
    } = this.props

    const {
      confirmedValidMet
    } = this.state

    if (isStatusInvalid && !confirmedValidMet) {
      showModal('ConfirmMetStatusModal', { onConfirm: this.confirmValidMet })
      return <div></div>
    }

    const onSubmit = () => {
      saveStatus({
        action: 'update',
        status: AGENT_STATUS_MET,
        payload: { note },
      })
    }

    return (
      <div className="StatusMetForm">
        <div className="ReferralStatusForm__body">
          { isTourUpdateNeeded && <PropertyTourQuestions /> }
          <NoteField />
        </div>
        <div className="ReferralStatusForm__footer">
          <StatusSubmitButton
            disabled={!hasTourInfoOrValidNote}
            onClick={onSubmit}>
            Update status
          </StatusSubmitButton>
        </div>
      </div>
    )
  }
}

const selector = createStructuredSelector({
  hasTourInfoOrValidNote: selectHasTourInfoOrValidNote,
  isTourUpdateNeeded: selectIsPropertyInquiryTourUpdateNeeded,
  note: selectNote,
  isAgentVideoCallEnabled: selectAgentVideoCallEnabled,
  isStatusInvalid: selectReferralStatusIsInvalid,
})

const actions = {
  saveStatus,
  showModal,
}

const withRedux = connect(selector, actions)

export const StatusMetForm = withRedux(withRouter(MetForm))
